import React from 'react';

import { HStack, VStack, theme } from '@squire/ui';

import { Skeleton } from '@/components/_shared/Skeleton';

import { styles } from './styles';

const ViewReservationSkeleton: React.FC = () => {
  return (
    <VStack
      space={theme.spacing[6]}
      paddingHorizontal={theme.spacing[5]}
      style={styles.skeletonContainer}
    >
      {/* Header row */}
      <HStack space={theme.spacing[4]} centerVertical>
        <Skeleton variant="circular" width={32} height={32} />
        <Skeleton width={250} height={24} />
      </HStack>

      {/* Appointment card */}
      <Skeleton width="100%" height={280} />

      {/* Shop info card */}
      <Skeleton width="100%" height={180} />

      {/* Payment status */}
      <Skeleton width="100%" height={80} />

      {/* Action buttons */}
      <VStack space={theme.spacing[3]}>
        <Skeleton width="100%" height={48} />
        <Skeleton width="100%" height={48} />
      </VStack>
    </VStack>
  );
};

ViewReservationSkeleton.displayName = 'ViewReservationSkeleton';
export { ViewReservationSkeleton };
